import React from 'react';
import { FaSearch, FaClock, FaClipboardList, FaChartBar } from "react-icons/fa";

const steps = [
  {
    icon: FaSearch,
    titulo: "1. Encuentra la convocatoria a la que postulas.",
    descripcion: "Podrás ver en nuestro sitio todas las convocatorias vigentes. Elige la tuya y empieza tu preparación.",
  },
  {
    icon: FaClock,
    titulo: "2. Prepárate en cualquier momento.",
    descripcion: "Como usuario de Apriori, la plataforma está disponible 24/7. Elige el momento adecuado para estudiar.",
  },
  {
    icon: FaClipboardList,
    titulo: "3. Disfruta de un contenido estructurado.",
    descripcion: "Nuestras pruebas siguen los parámetros de cada convocatoria: tiempo cronometrado y preguntas del eje temático.",
  },
  {
    icon: FaChartBar,
    titulo: "4. Comienza cuando quieras.",
    descripcion: "Genera confianza con Apriori, optimiza tu tiempo y crea familiaridad con el examen. Te mostramos resultados y avance.",
  },
];

const CardService = (props) =>{
  const Icon = props.icon;
  return(
      <div className="flex flex-row sm:flex-col md:flex-row items-start justify-start h-auto p-6 bg-white rounded-2xl shadow-md hover:shadow-xl transition duration-300">
          <div className="bg-primary bg-opacity-10 rounded-full p-3 mx-auto md:mx-0">
            <Icon className="text-2xl text-primary"/>
          </div>
          <div className="pl-0 md:pl-5 pt-3 md:pt-0 text-center md:text-left">
              <p className="text-lg font-bold text-fondo">{props.titulo}</p>
              <p className="font-normal text-gray-600 mt-1">{props.descripcion}</p> 
          </div>            
      </div>
   );
}

export default function NextQuestion(){
    return(
    <>
        <div  className="bg-fondo bg-no-repeat bg-cover" >
        <div className="flex flex-col items-center justify-around w-full p-8 pt-12">
            <p className="font-bold text-primary text-sm uppercase tracking-widest">
            ¿Cómo funciona Apriori?
            </p>
            <p className="w-full md:w-1/2 text-center text-2xl md:text-4xl font-bold mt-3 tracking-wide text-white">Rápido y sencillo</p>
        </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 auto-rows-min w-full p-6 pb-16 md:px-16 lg:px-24 landing-wrap">
            {steps.map((step) => (
              <CardService
                key={step.titulo}
                icon={step.icon}
                titulo={step.titulo}
                descripcion={step.descripcion}
              />
            ))}
        </div>

        </div>
    </>
    );
};
